import { render, staticRenderFns } from "./PDFModal.vue?vue&type=template&id=3490bfb9&scoped=true&"
import script from "./PDFModal.vue?vue&type=script&lang=js&"
export * from "./PDFModal.vue?vue&type=script&lang=js&"
import style0 from "./PDFModal.vue?vue&type=style&index=0&id=3490bfb9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3490bfb9",
  null
  
)

export default component.exports